import React from 'react';
import styled from 'styled-components';

import { currencyFormat } from '../../../../../../../utils/helpers/numberHelper';
import { PAYMENT_HANDLED_BY } from '../../../../utils/enums';

const Price = (props) => {
  const { version, app } = props;
  const { setupFee, monthlyFee } = version;
  const { paymentHandledBy } = app;

  if (paymentHandledBy === PAYMENT_HANDLED_BY.EXTERNAL) {
    return <StyledPrice>Contact for pricing</StyledPrice>;
  }

  if (setupFee === 0 && monthlyFee === 0) {
    return <StyledPrice block>Free</StyledPrice>;
  }

  return (
    <>
      {monthlyFee > 0 && (
        <StyledPrice>{currencyFormat(monthlyFee)} / month</StyledPrice>
      )}
      {setupFee > 0 && (
        <StyledPrice block>Setup Fee: {currencyFormat(setupFee)}</StyledPrice>
      )}
    </>
  );
};

const StyledPrice = styled.h4`
  color: var(--blue-dark);
  font-size: var(--heading-size-xs);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-narrow);
`;

export default Price;
